<template>
	<div id="printB2bOrderSection" class="printB2bOrderSection flex flex-col items-center w-full gap-5">
		<span class="flex flex-1 justify-center text-center font-bold text-3xl leading-8">
			{{ formattedRestaurantName }}
		</span>
		<span class="flex flex-1 justify-center text-center font-bold text-lg py-2 pt-4"
			>Orari: {{ formattedDocDate }}</span
		>
		<span class="font-bold text-3xl">Kodi: {{ order.code }}</span>
		<div class="divider" />
		<div class="flex flex-col">
			<span class="font-bold text-lg">Kodi Personal:</span>
			<div v-for="(b2BOrderGroupItem, index) in order.b2BOrderGroupItems" :key="index">
				<div class="flex flex-col">
					<div class="flex pt-4 pb-2 gap-2 items-center whitespace-nowrap">
						<span class="font-bold text-3xl leading-6">{{ b2BOrderGroupItem.code }}</span>
						<span v-if="b2BOrderGroupItem.employeeFirstName" class="font-bold italic text-xl"
							>({{ b2BOrderGroupItem.employeeFirstName }} {{ b2BOrderGroupItem.employeeLastName }})</span
						>
					</div>
					<div v-for="item in b2BOrderGroupItem['order'].items" :key="item.id" class="mb-4">
						<div class="flex flex-1 justify-between text-xl leading-6">
							<span>x{{ item['quantity'] }} {{ item['menuItem'].itemName }}</span>
							<span>
								{{ $filters.formatCurrency(item['itemValue'], order.business.currency) }}
							</span>
						</div>
						<div v-if="item.notes" class="flex gap-1">
							<span class="font-bold text-tiny">Notes:</span>
							<span class="text-tiny">{{ item.notes }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="divider" />
		<div class="flex justify-between">
			<span>Total</span>
			<span class="font-semibold">{{ $filters.formatCurrency(order.groupValue, order.business.currency) }}</span>
		</div>
		<p class="mt-4">*Ky nuk eshte kupon fiskal</p>
	</div>
</template>

<script>
	import moment from 'moment/moment';

	export default {
		name: 'PrintB2bOrderModal',
		data: () => ({
			order: {
				code: 0,
				business: {},
				company: {},
				courier: {},
				address: '',
				b2BOrderGroupItems: [],
				statusLogs: [],
				status: 'PENDING',
			},
		}),
		computed: {
			formattedDocDate() {
				return moment(this.order.docDate).format('HH:mm');
			},
			formattedRestaurantName() {
				if (!this.order.business?.restaurantName) {
					return '';
				}
				const name = this.order.business.restaurantName.toLowerCase().replace(/ at ?work$/, '');
				return name
					.split(' ')
					.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
					.join(' ');
			},
		},
		methods: {
			print() {
				// Get HTML to print from element
				const prtHtml = document.getElementById('printB2bOrderSection').innerHTML;

				// Get all stylesheets HTML
				let stylesHtml = '';
				for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
					stylesHtml += node.outerHTML;
				}

				// Open the print window
				const WinPrint = window.open(
					this.order.business.restaurantName,
					'',
					'left=0,top=0,width=700,height=600,toolbar=0,scrollbars=0,status=0'
				);

				WinPrint.document.write(`<!DOCTYPE html>
          <html lang="en">
            <head>
            <title>Print Order</title>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

				window.setTimeout(() => {
					WinPrint.document.close();
					WinPrint.focus();
					WinPrint.print();
					WinPrint.close();
				}, 50);
			},
		},
		mounted() {
			this.emitter.on('printB2bOrder', (order) => {
				this.order = order;
				this.$nextTick(() => {
					this.print();
				});
			});
		},
		beforeUnmount() {
			this.emitter.off('printB2bOrder', null);
		},
	};
</script>

<style lang="scss" scoped>
	.divider {
		@apply my-2;
		border-bottom: 1px dashed black;
	}

	.printB2bOrderSection {
		display: none;
	}

	@page {
		size: auto;
	}

	@media print {
		footer {
			display: none;
		}

		header {
			display: none;
		}
	}

	@media print {
		@page {
			margin-top: 20px;
			margin-bottom: 20px;
		}
		body {
			padding-top: 72px;
			padding-bottom: 72px;
		}
		.divider {
			@apply my-2;
			border-bottom: 1px solid black;
		}

		.printB2bOrderSection {
			display: none;
		}
	}
</style>
